// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeaderStyle {
    padding: 20px 3.75rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.header-appoiment-btn {
    border: 1px solid #294859;
    padding: 15px 23px;
    border-radius: 100px;
    background-color: #294859;
    font-size: 16px;
    line-height: 18.8px;
    font-family: 'PublicSans-Regular';
    color: #FFFFFF;
    cursor: pointer;
    box-shadow: 0px 4px 4px #00000040;
}

.navlink-view {
    font-size: 14px;
    line-height: 19.2px;
    font-family: 'Lora-Regular';
    color: #344054;
    text-decoration: none;
    padding: 13px 10px;
}

.border-lr {
    border-left: 1.7px solid #294859;
    border-right: 1.7px solid #294859;
}

.border-l {
    border-left: 1.7px solid #294859;
}

.herefor-style {
    display: flex;
    align-items: center;
    background-color: #F8F8F8;
    border-radius: 100px;
    padding: 0px 15px;
    box-shadow: 0px 4px 4px #00000040;
}

.here_text {
    font-size: 14px;
    line-height: 19.2px;
    font-family: 'Lora-Bold';
    color: #294859;
    padding: 15px 7px;
}

.logo-style {
    height: auto;
    width: 140px;
    object-fit: contain;
}

.hamburger-style {
    width: 28px;
    height: 28px;
    object-fit: contain;
    margin-left: 12px;
}

.cross-style {
    width: 24px;
    height: 24px;
    object-fit: contain;
    margin-left: 12px;
}

.mobile-view {
    display: none;
}

.mobilenav-container {
    background-color: rgba(0, 0, 0, 0.2);
    height: 100vh;
    left: 0;
    overflow: auto;
    position: fixed;
    top: 70px;
    width: 100%;
    z-index: 9999999;
    transition: opacity .15s linear;
    display: flex;
    align-items: center;
    justify-content: center;
}

.header-rightview {
    display: flex;
    align-items: center;
}

@media (max-width:600px) {
    .HeaderStyle {
        position: fixed;
        width: 100%;
        background-color: #FFFFFF;
        top: 0px;
        z-index: 9999999;
    }

    .logo-style {
        width: 126px;
    }

    .herefor-style {
        display: none;
    }

    .header-rightview {
        display: none;
    }

    .HeaderStyle {
        padding: 20px 20px;
    }

    .header-appoiment-btn {
        padding: 8px 16px;
        font-size: 13px;
    }

    .mobile-view {
        display: block;
    }
}

.header_modal_main {
    width: 80%;
}

.mobilenav-container {
    backdrop-filter: blur(3px);
    background-color: #ffffff59;
    background-image: linear-gradient(#c2c2c26e, #a2a2a238);
}

.header_modal_box {
    background-color: #FFFFFF;
    padding: 10px 20px;
    width: 100%;
    border-radius: 20px;
    box-shadow: 0px 0px 140px #000000;
    padding-bottom: 20px;
}

.header_mob_menu {
    margin: 0px;
    padding: 0px;
}

.header_mob_menu li {
    list-style: none;
    text-decoration: none;
    margin: 15px 0px;
}
/* 
.header_mob_menu li a {
    font-family: 'PublicSans-Regular';
    color: #294859;
    font-weight: 400;
    font-size: 18px;
    text-decoration: none;
} */

.header_bottom_nav {
    text-align: center;
}

.here_text_mobile {
    font-size: 16px;
    line-height: 19.2px;
    font-family: 'Lora-Bold';
    color: #294859;
}

.custome-dropdown {
    position: absolute;
    top: 70px;
    background-color: #fff;
    padding: 10px 22px;
    border-radius: 20px;
    /* width: 340px; */
    box-shadow: 0px 0px 2px #ddd;
    z-index: 999;
}


.custome-dropdown a {
    color: #294859;
    text-decoration: none;
    display: block;
    padding: 10px 0px;
    font-family: "Public Sans", Sans-serif;
    font-size: 16px;
    /* font-weight: 600; */
    line-height: 24px;
    min-width: 220px;
}

.mobile-dropdown {
    padding: 10px;
    padding-bottom: 0px;
}

.mobile-dropdown a {
    color: #294859;
    text-decoration: none;
    display: block;
    padding: 10px 0px;
    font-family: "Public Sans", Sans-serif;
    font-size: 14px;
    font-weight: 500;
}

.mobile-dropdown a img {
    width: 16px;
    margin-right: 10px;
}

.custome-dropdown :hover {
    border-bottom: 1px solid #294859;
}

.custome-dropdown a img {
    width: 18px;
    margin-right: 12px;
}

.consultdropdown {
    display: none;
}

.consultmain:hover .consultdropdown {
    display: block;
}

.Testingdropdown {
    display: none;
}

.Testingmain:hover .Testingdropdown {
    display: block;
}

.Treatmentdropdown {
    display: none;
}

.Treatmentmain:hover .Treatmentdropdown {
    display: block;
}

.aboutshow {
    display: none;
}

.aboutbtn:hover .aboutshow {
    display: block;
}

.header_mob_menu .navlink-view{
        padding: 13px 7px;
}`, "",{"version":3,"sources":["webpack://./src/components/Header/style.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,iCAAiC;IACjC,cAAc;IACd,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;IACd,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,wBAAwB;IACxB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,OAAO;IACP,cAAc;IACd,eAAe;IACf,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,yBAAyB;QACzB,QAAQ;QACR,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,uDAAuD;AAC3D;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,iCAAiC;IACjC,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;AACA;;;;;;;GAOG;;AAEH;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;IAC5B,YAAY;AAChB;;;AAGA;IACI,cAAc;IACd,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,sCAAsC;IACtC,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,sCAAsC;IACtC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;QACQ,iBAAiB;AACzB","sourcesContent":[".HeaderStyle {\n    padding: 20px 3.75rem;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.header-appoiment-btn {\n    border: 1px solid #294859;\n    padding: 15px 23px;\n    border-radius: 100px;\n    background-color: #294859;\n    font-size: 16px;\n    line-height: 18.8px;\n    font-family: 'PublicSans-Regular';\n    color: #FFFFFF;\n    cursor: pointer;\n    box-shadow: 0px 4px 4px #00000040;\n}\n\n.navlink-view {\n    font-size: 14px;\n    line-height: 19.2px;\n    font-family: 'Lora-Regular';\n    color: #344054;\n    text-decoration: none;\n    padding: 13px 10px;\n}\n\n.border-lr {\n    border-left: 1.7px solid #294859;\n    border-right: 1.7px solid #294859;\n}\n\n.border-l {\n    border-left: 1.7px solid #294859;\n}\n\n.herefor-style {\n    display: flex;\n    align-items: center;\n    background-color: #F8F8F8;\n    border-radius: 100px;\n    padding: 0px 15px;\n    box-shadow: 0px 4px 4px #00000040;\n}\n\n.here_text {\n    font-size: 14px;\n    line-height: 19.2px;\n    font-family: 'Lora-Bold';\n    color: #294859;\n    padding: 15px 7px;\n}\n\n.logo-style {\n    height: auto;\n    width: 140px;\n    object-fit: contain;\n}\n\n.hamburger-style {\n    width: 28px;\n    height: 28px;\n    object-fit: contain;\n    margin-left: 12px;\n}\n\n.cross-style {\n    width: 24px;\n    height: 24px;\n    object-fit: contain;\n    margin-left: 12px;\n}\n\n.mobile-view {\n    display: none;\n}\n\n.mobilenav-container {\n    background-color: rgba(0, 0, 0, 0.2);\n    height: 100vh;\n    left: 0;\n    overflow: auto;\n    position: fixed;\n    top: 70px;\n    width: 100%;\n    z-index: 9999999;\n    transition: opacity .15s linear;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.header-rightview {\n    display: flex;\n    align-items: center;\n}\n\n@media (max-width:600px) {\n    .HeaderStyle {\n        position: fixed;\n        width: 100%;\n        background-color: #FFFFFF;\n        top: 0px;\n        z-index: 9999999;\n    }\n\n    .logo-style {\n        width: 126px;\n    }\n\n    .herefor-style {\n        display: none;\n    }\n\n    .header-rightview {\n        display: none;\n    }\n\n    .HeaderStyle {\n        padding: 20px 20px;\n    }\n\n    .header-appoiment-btn {\n        padding: 8px 16px;\n        font-size: 13px;\n    }\n\n    .mobile-view {\n        display: block;\n    }\n}\n\n.header_modal_main {\n    width: 80%;\n}\n\n.mobilenav-container {\n    backdrop-filter: blur(3px);\n    background-color: #ffffff59;\n    background-image: linear-gradient(#c2c2c26e, #a2a2a238);\n}\n\n.header_modal_box {\n    background-color: #FFFFFF;\n    padding: 10px 20px;\n    width: 100%;\n    border-radius: 20px;\n    box-shadow: 0px 0px 140px #000000;\n    padding-bottom: 20px;\n}\n\n.header_mob_menu {\n    margin: 0px;\n    padding: 0px;\n}\n\n.header_mob_menu li {\n    list-style: none;\n    text-decoration: none;\n    margin: 15px 0px;\n}\n/* \n.header_mob_menu li a {\n    font-family: 'PublicSans-Regular';\n    color: #294859;\n    font-weight: 400;\n    font-size: 18px;\n    text-decoration: none;\n} */\n\n.header_bottom_nav {\n    text-align: center;\n}\n\n.here_text_mobile {\n    font-size: 16px;\n    line-height: 19.2px;\n    font-family: 'Lora-Bold';\n    color: #294859;\n}\n\n.custome-dropdown {\n    position: absolute;\n    top: 70px;\n    background-color: #fff;\n    padding: 10px 22px;\n    border-radius: 20px;\n    /* width: 340px; */\n    box-shadow: 0px 0px 2px #ddd;\n    z-index: 999;\n}\n\n\n.custome-dropdown a {\n    color: #294859;\n    text-decoration: none;\n    display: block;\n    padding: 10px 0px;\n    font-family: \"Public Sans\", Sans-serif;\n    font-size: 16px;\n    /* font-weight: 600; */\n    line-height: 24px;\n    min-width: 220px;\n}\n\n.mobile-dropdown {\n    padding: 10px;\n    padding-bottom: 0px;\n}\n\n.mobile-dropdown a {\n    color: #294859;\n    text-decoration: none;\n    display: block;\n    padding: 10px 0px;\n    font-family: \"Public Sans\", Sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.mobile-dropdown a img {\n    width: 16px;\n    margin-right: 10px;\n}\n\n.custome-dropdown :hover {\n    border-bottom: 1px solid #294859;\n}\n\n.custome-dropdown a img {\n    width: 18px;\n    margin-right: 12px;\n}\n\n.consultdropdown {\n    display: none;\n}\n\n.consultmain:hover .consultdropdown {\n    display: block;\n}\n\n.Testingdropdown {\n    display: none;\n}\n\n.Testingmain:hover .Testingdropdown {\n    display: block;\n}\n\n.Treatmentdropdown {\n    display: none;\n}\n\n.Treatmentmain:hover .Treatmentdropdown {\n    display: block;\n}\n\n.aboutshow {\n    display: none;\n}\n\n.aboutbtn:hover .aboutshow {\n    display: block;\n}\n\n.header_mob_menu .navlink-view{\n        padding: 13px 7px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
